import { createAxios, createAxiosHeaders } from "./axiosHttpMarconi";

export const expedienteServicioService = {
  getExpedientesServicios,
  putExpediente,
  getExpedienteServicioById,
  getExcel,
};

function getExpedientesServicios(pagination, filters) {
  const axios = createAxios();
  const user = JSON.parse(localStorage.getItem("user"));
  let urlPath = `franquiciadora/${user.extraData.franquiciadoraId}/expedientes-servicios`;
  const pagination_service = {
    page: pagination.currentPage - 1,
    limit: pagination.perPage,
  };

  const params = new URLSearchParams({ ...pagination_service, ...filters });

  urlPath += `?${params.toString()}`;
  return axios.get(urlPath);
}

function putExpediente(id, request) {
  const axios = createAxios();
  const user = JSON.parse(localStorage.getItem("user"));
  let urlPath = `franquiciadora/${user.extraData.franquiciadoraId}/expedientes-servicios/${id}`;
  return axios.put(urlPath, request);
}

function getExpedienteServicioById(id) {
  const axios = createAxios();
  const user = JSON.parse(localStorage.getItem("user"));
  let urlPath = `franquiciadora/${user.extraData.franquiciadoraId}/expedientes-servicios/${id}`;
  return axios.get(urlPath);
}

function getExcel(filters) {
  const axios = createAxiosHeaders();
  const user = JSON.parse(localStorage.getItem("user"));
  let urlPath = `/franquiciadora/${user.extraData.franquiciadoraId}/expedientes-servicios/excel`;
  const params = new URLSearchParams({ ...filters, ...{ limit: 2000 } });
  urlPath += `?${params.toString()}`;

  return axios.get(urlPath, { responseType: "blob" }).then((response) => {
    const contentDisposition = response.headers["content-disposition"];
    const fileName = contentDisposition;
    return Promise.resolve({ blob: response.data, fileName: fileName });
  });
}
